import axios from 'axios';
import moment from 'moment';
import React, { useState } from 'react';
import DayPicker from 'react-day-picker';

import { connect, useDispatch } from 'react-redux';
import '../../../../node_modules/moment/locale/id';
import MomentLocaleUtils from '../../../../node_modules/react-day-picker/moment';

function getWeekDays(weekStart) {
  const days = [weekStart];
  for (let i = 1; i < 7; i += 1) {
    days.push(moment(weekStart).add(i, 'days').toDate());
  }
  return days;
}

function getWeekRange(date) {
  return {
    from: moment(date).startOf('week').toDate(),
    to: moment(date).endOf('week').toDate(),
  };
}

const WEEKDAYS_SHORT = {
  id: ['M', 'S', 'S', 'R', 'K', 'J', 'S'],
};

const DayPickerWrap = ({ setData, course_detail }) => {
  const dateDefault = getWeekDays(getWeekRange(new Date()).from);
  const hoverRangeOld = getWeekRange(new Date());
  const [hoverRange, setHoverRange] = useState(hoverRangeOld);
  const [selectedDays, setSelectedDays] = useState(dateDefault);
  const dispatch = useDispatch();

  const handleDayChange = (date) => {
    const d = getWeekDays(getWeekRange(date).from);
    const dateRange = moment(d[0])
      .format('DD MMMM YYYY')
      .concat(' - ', moment(d[6]).format('DD MMMM YYYY'));

    setSelectedDays(getWeekDays(getWeekRange(date).from));
    setData(dateRange);
    fetchSchedules(
      moment(d[0]).format('YYYY-MM-DD'),
      moment(d[6]).format('YYYY-MM-DD'),
      course_detail.id,
    );
  };

  const fetchSchedules = (start_date, end_date, course_id) => {
    const access_token = localStorage.getItem('access_token');
    axios
      .get(
        window.$API_URL +
          `api/course/fetchschedules?start_date=${start_date}&end_date=${moment(end_date)
            .add('days', 1)
            .format('YYYY-MM-DD')}&course_id=${course_id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${access_token}`,
          },
        },
      )
      .then((response) => {
        if (response.data.success) {
          dispatch({
            type: 'ADD_SCHEDULE_LIST',
            payload: response.data.data,
          });
        }
      })
      .catch((error) => {});
  };

  const handleDayEnter = (date) => {
    setHoverRange(getWeekRange(date));
  };

  const handleDayLeave = () => {
    getWeekRange(undefined);
  };

  const handleWeekClick = (weekNumber, days, e) => {
    setSelectedDays(days);
  };

  const daysAreSelected = selectedDays.length > 0;

  const modifiers = {
    hoverRange,
    selectedRange: daysAreSelected && {
      from: selectedDays[0],
      to: selectedDays[6],
    },
    hoverRangeStart: hoverRange && hoverRange.from,
    hoverRangeEnd: hoverRange && hoverRange.to,
    selectedRangeStart: daysAreSelected && selectedDays[0],
    selectedRangeEnd: daysAreSelected && selectedDays[6],
  };

  return (
    <div className="SelectedWeekExample">
      <DayPicker
        weekdaysShort={WEEKDAYS_SHORT.id}
        selectedDays={selectedDays}
        showOutsideDays
        modifiers={modifiers}
        onDayClick={handleDayChange}
        onDayMouseEnter={handleDayEnter}
        onDayMouseLeave={handleDayLeave}
        onWeekClick={handleWeekClick}
        onMonthChange={(d) => {
          const month = moment(d).format('MMMM');
          const firstDay = moment(selectedDays[0]).format('DD');
          const firstYear = moment(selectedDays[0]).format('YYYY');
          let firsDate = firstDay.concat(' ', month, ' ', firstYear);
          firsDate = moment(firsDate, 'DD MMMM YYYY').toDate();

          const date = getWeekDays(getWeekRange(firsDate).from);
          const dateRange = moment(date[0])
            .format('DD MMMM YYYY')
            .concat(' - ', moment(date[6]).format('DD MMMM YYYY'));

          setSelectedDays(getWeekDays(getWeekRange(firsDate).from));
          setData(dateRange);
        }}
        localeUtils={MomentLocaleUtils}
        locale={'id'}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return { course_detail: state.course_detail, schedule_list: state.schedule_list };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DayPickerWrap);
